import { render, staticRenderFns } from "./CreateCustomBill.vue?vue&type=template&id=17ba9a8b&"
import script from "./CreateCustomBill.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports